import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListItemPricesRequest extends IBaseRequest {
    itemId: number;
}

export class ListItemPricesRequest extends BaseRequest implements IListItemPricesRequest {
    public itemId: number;

  constructor(server: string, session: string, itemId: number) {
    super(server, session);
    this.itemId = itemId;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.itemId, 'itemId');
    
    return super.wrapperXml('ListItemPrices', parameters);
  }
}
